'use client';

import React from 'react';
import Link from 'next/link';

function Page() {
  return (
    <>
      <div className="flex flex-col md:flex-row justify-center items-center gap-8 min-h-[calc(100vh-130px)] p-6">
        <div className="card w-80 bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
          <figure className="pt-10">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-24 w-24"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 6h18M3 12h18M3 18h18"
              />
            </svg>
          </figure>
          <div className="card-body items-center text-center">
            <h2 className="card-title text-2xl">Catering</h2>
            <p>Professional catering services for your events</p>
            <div className="card-actions mt-4">
              <Link href="/order?type=catering" className="btn btn-primary">
                Select
              </Link>
            </div>
          </div>
        </div>

        <div className="card w-80 bg-base-100 shadow-xl hover:shadow-2xl transition-shadow">
          <figure className="pt-10">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-24 w-24"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 10V3L4 14h7v7l9-11h-7z"
              />
            </svg>
          </figure>
          <div className="card-body items-center text-center">
            <h2 className="card-title text-2xl">Delivery</h2>
            <p>Quick and reliable food delivery to your location</p>
            <div className="card-actions mt-4">
              <Link href="/order?type=delivery" className="btn btn-primary">
                Select
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Page;
